import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryCategoryListResponse,
  IInventoryCategoryListResponseData,
} from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export type IInventoryCategoryTypes = "categories" | "sub-categories" | "sub-subcategories";

export const useInventoryProductCategoryDropdownAPI = (catalogueType: IInventoryCategoryTypes) => {
  const [searchResults, setSearchResults] = useState<IInventoryCategoryListResponseData[]>([]);

  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const appendInResult = (data: IInventoryCategoryListResponseData) => {
    setSearchResults((prev) => {
      return [...prev, data];
    });
  };
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(`${INVENTORY_MODULE?.PRODUCT_CATEGORY_LIST?.baseURL}${catalogueType}/`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IInventoryCategoryListResponse>) => {
          if (res.data.status === true) {
            setSearchResults(res.data.data);
          } else {
            // dispatch(setBatchList({ data: [] }));
            setSearchResults([]);
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          setSearchResults([]);

          dispatch(
            setLoading({
              key: "isTaxListLoadingInProgress",
              status: false,
            }),
          );
          captureError(e)
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return { searchResults, appendInResult, execute };
};
